export const CACHE_KEY_LIST_LABDATA_INCIDENTS = 'lab-data-incidents';
export const CACHE_KEY_ONE_LABDATA_INCIDENT = 'lab-data-one-incident';
export const ROUTE_PATH_LABDATA_INCIDENTS = '/incidents/list/lab-data';

export const CACHE_KEY_LIST_LABDATA_EVIDENCES = 'lab-data-evidences';
export const CACHE_KEY_ONE_LABDATA_EVIDENCE = 'lab-data-one-evidence';

export const LABDATA_ISSUE_STATUS = {
  DRAFT : 'DRAFT',
  RUNNING : 'RUNNING',
  SOLVED : 'SOLVED',
};

export const LABDATA_ISSUE_STATUS_APPEARANCE = {
  DRAFT: {color: '#DB6307'},
  RUNNING: {color: '#096dd9'},
  SOLVED: {color: '#389e0d'},
};

export const options = [
  {
    title: 'options',
    action: 'options',
    style: {minWidth: 120},
    disabled: true
  },
  {
    title: 'details',
    action: 'details',
    style: {minWidth: 120},
    permissions:['LAB_DATA_ISSUES_VIEW']
  },
];
